export default {
  methods: {
    scrollToComponent(elementComponent) {
      elementComponent.$el.scrollIntoView({ behavior: 'smooth', block: 'center' })
    },
    scrollToElement(element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'center' })
    }
  }
}